import api from '../components/Api/api';

export const getRegions = async () => {
  try {
    const response = await api.get('/geos/regions/minimal');
    return response.data;
  } catch (error) {
    console.error('Error fetching regions:', error);
    throw error;
  }
};

export const getRegionById = async (regionId) => {
  try {
    const regions = await getRegions();
    return regions.find(region => region.id === parseInt(regionId));
  } catch (error) {
    console.error('Error fetching region by ID:', error);
    throw error;
  }
}; 